export default __webpack_public_path__ + "static/media/waterpool.cced5603.png";